<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1+LlUBMFWtrGjgEQjYAq0I7XTjumz3U1TM=","cpf":"U2FsdGVkX1/RvqIoULVS1VgTp+TJwaWCGRO1zPKkoP0="},{"num_cand":"U2FsdGVkX1/fqJvHlL7ewPIZjiqAX49AALmU4uf1mEo=","cpf":"U2FsdGVkX19q6FJM+KvSMbdraE3tNPEUCA6PaTvHW+I="},{"num_cand":"U2FsdGVkX18B06j+XszbUr9Jpd7svHAOfWFZ6mB+7ls=","cpf":"U2FsdGVkX1+JC8Taq/8JcrBoUlNOqnDgXs2SF90D044="},{"num_cand":"U2FsdGVkX19vI40pBbt7PUGISPkPNFYassFYM8xuHLw=","cpf":"U2FsdGVkX18hM6sxUYSvg3/FWcPSrkzkxNLGxbGxN+g="},{"num_cand":"U2FsdGVkX1/GyhTDx61AdZ9+S/yBML0D0jY7aCcsmLI=","cpf":"U2FsdGVkX1+ZYqect+YcnQ2yu64q+Y74M2UbwnyxvuI="},{"num_cand":"U2FsdGVkX19msjs9MNdsPzDdY5PYapW0XCKq4oBric4=","cpf":"U2FsdGVkX18ojaGiaMEZrqMIwpAeJPUEXwuBJ2TXpkE="},{"num_cand":"U2FsdGVkX1/DFytbLyQTQlx+mGGYBrh7Cwr7m2wybxQ=","cpf":"U2FsdGVkX1+y4AvYFZMRTOtT3W0pv3X4vIDbe3NbwGY="},{"num_cand":"U2FsdGVkX18LLDSbHapShkk1AtQo1IaQ2ceMYqcfBWc=","cpf":"U2FsdGVkX19r+6FEPy999TdcRTc9L+C7orXTA43BUHw="},{"num_cand":"U2FsdGVkX1/nnaJBKZnwPQywHamNXoeaWbIJBrV+/6o=","cpf":"U2FsdGVkX199eCk7W5kWqE2UUDbdxSolLSq66IuJKJA="},{"num_cand":"U2FsdGVkX18q59AeKZbW6bX8ayzecgAwgNqEG8Oj7Ns=","cpf":"U2FsdGVkX1+YDES5PrWm20F8o+LvNCKLUrT8kc6wbHc="},{"num_cand":"U2FsdGVkX1/Ngas1pFhHR/iAyOinNtkQ7Zh33iIYyZ8=","cpf":"U2FsdGVkX19Q8lB74zL3Tngv6TxHZsrUpXNavtaK4ZA="},{"num_cand":"U2FsdGVkX1/uL3+Xk0wnjsZAaXzoVq74BwGqc7pUYeQ=","cpf":"U2FsdGVkX1+S4PpN0FvWIudj67MrwPWa0ySQCZEzyu0="},{"num_cand":"U2FsdGVkX19KyIgazeKKhc2U952Zc9mLIXwUNeC4Nbs=","cpf":"U2FsdGVkX189cMMYxLj4bQKzKLlwwPcFXAKyMMYFQHU="},{"num_cand":"U2FsdGVkX18RPncvW+Ms+dpvTjMvIe4k8JDOIaFvDvE=","cpf":"U2FsdGVkX18bwgxlUu0eTEXcXmJyMOOY/1cXSaX6qZM="},{"num_cand":"U2FsdGVkX19SMB+BzOmvSN1tQBdDQkyL819HJgeidvU=","cpf":"U2FsdGVkX1/UdK0VKuxAHvzdPAqjtATZrN26vVaQuo8="},{"num_cand":"U2FsdGVkX1/WSM6FUA+dSCJAHZV00wxunjsPCFLimBw=","cpf":"U2FsdGVkX19wPaexMn0XS5hiYJbMS0iTovitUQ3n11Y="},{"num_cand":"U2FsdGVkX1/kTlSGAEa2SRiMUecB4sABj9h2Z0kvQZk=","cpf":"U2FsdGVkX1+hkek2bJKdFC7G7CL1A9GH77H0EN3RSkk="},{"num_cand":"U2FsdGVkX18QiWATHRfvQPHO34Tkacq9QeF0ICr3ZCI=","cpf":"U2FsdGVkX19TKmc11uU10to1vcxuBLKk67xNEsJo+ec="},{"num_cand":"U2FsdGVkX1/pSGffFTcpDar5FuoVNEhqq3DTWWhKtsk=","cpf":"U2FsdGVkX1+M2weawHn1eqHD9Py3uCGyOg0XJQjZJB0="},{"num_cand":"U2FsdGVkX1+MBTSu3y3OvYkInwL9pnUDlZRkTYHEPiM=","cpf":"U2FsdGVkX19N8SSfAWqmVH1USnvs5GGnCe+X6p0lZRw="},{"num_cand":"U2FsdGVkX18HgRHLwIFY/fMUXaD/HLhsfcHOT9+AWqg=","cpf":"U2FsdGVkX18WVa5EbO3wc8kLJH40WTjmmTCM85MB/Fc="},{"num_cand":"U2FsdGVkX1+pu3ZxPuxxs9T0aNs6w7EMHf3Fx/Of7QE=","cpf":"U2FsdGVkX1+XX8CwVm0PimX5FsSUx02IqlQl+P/I+Eo="},{"num_cand":"U2FsdGVkX192Y68e5nv/Kb2kUHlUOPX/l+Krey5iN0E=","cpf":"U2FsdGVkX1/hbtwEIlt0L69hcemCeC+CLMivMy6n4eU="},{"num_cand":"U2FsdGVkX1/bcxOX4p8dEVYREzOoC5bO88KVelasGX8=","cpf":"U2FsdGVkX190o+Qlsrd3yN6b1vVsXt1gDVo737ig2Hc="},{"num_cand":"U2FsdGVkX1/YI5W45tpJHEy5UzRrzaM41kkyKCDzOQs=","cpf":"U2FsdGVkX19TP3qadmo9WubqflUwKJW7rRDq5Vr+vcQ="},{"num_cand":"U2FsdGVkX1/b1VDxRBtUtDcHNmMVjWZlAXToVt9GJV4=","cpf":"U2FsdGVkX185EntkTplptMnyp6f9UGw5QskXXlaYd4Q="},{"num_cand":"U2FsdGVkX19CmxRLZbfGqwrgCHdMsKl2AKTWyRKY7ps=","cpf":"U2FsdGVkX18CJBeQ0PfbxSHxydD9/s8uQVvdBDZ7Gdo="},{"num_cand":"U2FsdGVkX180df85VyNaM3st4VtxaPZByGWH343fidc=","cpf":"U2FsdGVkX1/GSsqbNV1KIzH9VNSDpePMjYubKVil0ek="},{"num_cand":"U2FsdGVkX18HT6Ue68TNJo6rHOOhgbdla1Rzy6rCXMA=","cpf":"U2FsdGVkX186yx/U7cPh2E3jl4cge91muEG21m9PGCU="},{"num_cand":"U2FsdGVkX1+LvrHeo0vCklZ3CBg8pBD0EeQPVT3HobU=","cpf":"U2FsdGVkX1/dJw1n4gCqkcpBS0Hd0P2VMR1/vJPcWp4="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2217/rec_isen2/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
